import * as React from "react";
const SvgCheckmarkSimple = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m10.5 17.6-6.1-6 2.2-2.2 3.9 4 7.4-7.5 2.2 2.2-9.6 9.5Z", fill: "#000" }));
export default SvgCheckmarkSimple;
